// extracted by mini-css-extract-plugin
export default {"loginSignupHeader":"login_loginSignupHeader__Fdwjn","loginForm":"login_loginForm__OeSo2","field":"login_field__4qcyu"};